module.exports = __webpack_public_path__ + "static/media/number.560622d2.png";